import { render } from "./PopupDanhSachVeMuaGhePhu.vue?vue&type=template&id=60edd919&scoped=true"
import script from "./PopupDanhSachVeMuaGhePhu.vue?vue&type=script&lang=js"
export * from "./PopupDanhSachVeMuaGhePhu.vue?vue&type=script&lang=js"

import "./PopupDanhSachVeMuaGhePhu.vue?vue&type=style&index=0&id=60edd919&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60edd919"]])

export default __exports__